export class CustomerDetailsModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}
